import { AdminApplicationState, RootState, Application } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import ApplicationService from '@/services/application.service';
import { ApplicationMutator } from '@/mutators/application.mutator';

type AdminApplicationGetter = GetterTree<AdminApplicationState, RootState>;

export const initialState = (): AdminApplicationState => {
  return {
    initialState,
    applications: [],
    filters: {},
    total: 0,
    availableDashboards: [],

  };
};

export const getters: AdminApplicationGetter = {
  adminApplications: (state) => state,
  adminApplicationById: (state) => (id: string) => state.applications.find((i: Application) => i.id === id),
  adminApplicationsTabular: (state) => state.applications.map(ApplicationMutator.toTabular),
  availableDashboards: (state) => state.availableDashboards,
};

export const mutations: MutationTree<AdminApplicationState> = {
  addAdminApplications(state, newAdminApplications) {
    state.applications = newAdminApplications.applications;
    state.total = newAdminApplications.total;
  },
  addAdminDashboards(state, dashboards) {
    state.availableDashboards = dashboards;
  },
  addAdminApplication(state, newApplication) {
    state.total = state.total + 1;
    state.applications.push(newApplication);
  },
  deleteAdminApplication(state, applicationId) {
    state.applications = [
      ...state.applications.filter((element: any) => element.id !== applicationId),
   ];
  },
  updateAdminApplication(state, updatedApplication: Application) {
    state.applications = [
      ...state.applications.filter((element: any) => element.id !== updatedApplication.id),
      updatedApplication,
   ];
  },
};

export const actions: ActionTree<AdminApplicationState, RootState> = {
  async addAdminApplicationsAsync(context: any, pagination: {
    take: number, skip: number, sort: string, desc: boolean, filters: object,
  }): Promise<void> {
    const apps = await ApplicationService.getAdminApplications(
      // pagination.take, pagination.skip, pagination.sort, pagination.desc, pagination.filters,
    );
    context.commit('addAdminApplications', apps.applications);
  },

  async createAdminApplicationAsync(context, details): Promise<Application> {
    const application = await ApplicationService.createApplication(details);
    context.commit('addAdminApplication', application);
    return application;
  },

  async deleteAdminApplicationAsync(context, applicationId) {
    await ApplicationService.deleteApplication(applicationId);
    context.commit('deleteAdminApplication', applicationId);
  },

  async updateAdminApplicationAsync(context: any, application: { id: number, payload: object }): Promise<Application> {
    const updatedApplication = await ApplicationService.updateApplication(application.id, application.payload);
    context.commit('updateAdminApplication', updatedApplication);
    return updatedApplication;
  },

  async addAdminDashboardsAsync(context: any, pagination: {
    take: number, skip: number, sort: string, desc: boolean, filters: object,
  }) {
    const dashboards = await ApplicationService.getAdminDashboards();
    context.commit('addAdminDashboards', dashboards);
  },
};

export const adminApplications: Module<AdminApplicationState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
